const KEY = "jt_visitor_id";

export function getVisitorId() {
  let v = localStorage.getItem(KEY);
  if (!v) {
    v = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(KEY, v);
  }
  return v;
}
